import { useContext } from 'react';
import ThemeContext from '../components/Theme/ThemeContext';

function useThemeAnimation() {
    const { animated, animationConfig } = useContext(ThemeContext);
    return [animated, animationConfig] as const;
}

export default useThemeAnimation;
